export default "__VITE_ASSET__fd96c3b2__"